export default __webpack_public_path__ + "static/media/hackernoon.0d1b57b7.jpeg";